'use strict';

var simpleMerge = require('./simpleMerge');

function simpleClone(obj) {
  return simpleMerge({}, obj);
}

module.exports = simpleClone;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/simpleClone.js
// module id = 70
// module chunks = 0